// hooks/useScholarshipStats.js
import { useMemo } from "react";

export const useScholarshipStats = (scholarships) => {
  return useMemo(() => {
    if (!scholarships?.length) return null;
    let given = 0,
      total = 0,
      amountGiven = 0,
      amountTotal = 0;

    scholarships.forEach((s) => {
      const count = s.awardHistory?.length || 0;
      const amt = s.award_amount || 0;
      given += count;
      total += s.number_of_awards;
      amountGiven += count * amt;
      amountTotal += s.number_of_awards * amt;
    });

    return {
      given,
      total,
      amountGiven,
      amountTotal,
      remaining: total - given,
      amountRemaining: amountTotal - amountGiven,
    };
  }, [scholarships]);
};
